module.exports = __webpack_public_path__ + "img/bg_4.80b7fd3e.png";